// 同一环境的各站点：本地开发各占一个端口；远端域名是后台域名去掉 admin- 前缀，创作台再加 studio- 前缀。
const LOCAL_ORIGINS = { player: 'http://localhost:5182', studio: 'http://localhost:5183' }
const REMOTE_PREFIXES = { player: '', studio: 'studio-' }

/**
 * 从后台地址换算同一环境里玩家端或创作台的地址。
 * @param {string} adminOrigin
 * @param {'player'|'studio'} site
 * @param {string} pathname
 */
export function visualGameSiteUrl(adminOrigin, site, pathname) {
  const adminUrl = new URL(adminOrigin)

  if (adminUrl.hostname === 'localhost' || adminUrl.hostname === '127.0.0.1') {
    return new URL(pathname, LOCAL_ORIGINS[site])
  }

  if (!adminUrl.hostname.startsWith('admin-')) {
    throw new Error(`Visual Game Admin hostname must start with admin-: ${adminUrl.hostname}`)
  }

  const siteUrl = new URL(pathname, adminUrl.origin)
  siteUrl.hostname = `${REMOTE_PREFIXES[site]}${adminUrl.hostname.slice('admin-'.length)}`
  return siteUrl
}

export function visualGamePreviewUrl(adminOrigin) {
  return visualGameSiteUrl(adminOrigin, 'player', '/game')
}
